import React from 'react'
import Chatbot from '../components/HomePage/Chatbot';


export default function Default(){
    return(
        <div className="Default">
            <Chatbot/>
        </div>
    )
}